import React from "react";

export const ErrorPage = () => {
  return <div className="ErrorPage">ErrorPage</div>;
};
